var _defs, _rect, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgG17({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.944,
    height: 80.948,
    viewBox: "0 0 80.944 80.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.944,
    height: 80.948,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80.944,
    height: 80.948,
    fill: "#1a476b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.112,6.784V23.1H9.368V10.611H9.344l-1.926,2H7.394V9.745L9.922,6.784Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.364,6.784h6.885V9.311L16.662,23.1H13.941L17.6,9.022H13.364Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.113,49.795a10.513,10.513,0,0,0,3.38-7.726,10.72,10.72,0,0,0-.089-1.348,8.406,8.406,0,0,1,4.752,14.592,10.564,10.564,0,0,0-8.043-5.518M55.27,60.26A8.406,8.406,0,0,1,42.7,67.574a10.5,10.5,0,0,0,2.7-9.261,10.517,10.517,0,0,0,9.7.264,8.348,8.348,0,0,1,.171,1.683m-28.64.07a8.292,8.292,0,0,1,.185-1.745,10.523,10.523,0,0,0,9.674-.264,10.482,10.482,0,0,0,2.8,9.272A8.4,8.4,0,0,1,26.63,60.33M22.978,49.093A8.433,8.433,0,0,1,30.5,40.721a10.72,10.72,0,0,0-.088,1.348,10.521,10.521,0,0,0,3.444,7.788,10.562,10.562,0,0,0-8.083,5.478,8.392,8.392,0,0,1-2.79-6.242M40.949,33.649a8.429,8.429,0,0,1,7.719,5.063,10.58,10.58,0,0,0-7.719,5.924,10.568,10.568,0,0,0-7.717-5.924,8.428,8.428,0,0,1,7.717-5.063m2,19.153A8.391,8.391,0,0,1,54.4,56.55,8.394,8.394,0,0,1,42.954,52.8m-4.036.057a8.39,8.39,0,0,1-11.388,3.7,8.39,8.39,0,0,1,11.388-3.7M32.64,40.774a8.342,8.342,0,0,1,7.068,9.612,8.342,8.342,0,0,1-7.068-9.612m8.349,25.517A8.394,8.394,0,0,1,40.911,54.3a8.4,8.4,0,0,1,.078,11.994M49.37,42.069a8.424,8.424,0,0,1-7.178,8.317,8.342,8.342,0,0,1,7.068-9.612,8.369,8.369,0,0,1,.11,1.3m11.675,7.024A10.556,10.556,0,0,0,50.89,38.558a10.542,10.542,0,0,0-19.881,0A10.535,10.535,0,0,0,24.924,57.4,10.536,10.536,0,0,0,41,69.025,10.537,10.537,0,0,0,56.993,57.392a10.533,10.533,0,0,0,4.052-8.3",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.955,7.688v2.605h.41a.478.478,0,0,0,.546-.547V8.225c0-.361-.166-.537-.546-.537Zm-1.112-.907h1.649c1.122,0,1.532.556,1.532,1.483v1.4c0,.926-.41,1.492-1.532,1.492h-.537V13.4H25.843Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.556,11.3h.888L31,8.644H31Zm-1.4,2.1L30.41,6.781h1.268L32.936,13.4H31.8l-.2-1.21H30.41l-.195,1.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6,7.688V9.746h.371a.481.481,0,0,0,.546-.546V8.225c0-.361-.165-.537-.546-.537Zm0,2.673V13.4H33.493V6.781h1.619c1.122,0,1.532.556,1.532,1.483v.848c0,.713-.253,1.132-.888,1.278L36.82,13.4H35.649Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.036,6.781h2.956v.907h-.917V13.4H37.953V7.688h-.917Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.632,9.24V13.4h-.937V6.782h1.093l1.2,3.794V6.782h.927V13.4h-.976Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.832,6.781h2.654v.907H45.944V9.581h1.1v.9h-1.1v2.01h1.542V13.4H44.832Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.291,7.688V9.746h.371a.481.481,0,0,0,.546-.546V8.225c0-.361-.165-.537-.546-.537Zm0,2.673V13.4H48.179V6.781H49.8c1.122,0,1.532.556,1.532,1.483v.848c0,.713-.253,1.132-.888,1.278L51.506,13.4H50.335Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.887,11.971v-.888h1.034v.907c0,.371.166.586.547.586.35,0,.507-.234.507-.586v-.253a1.2,1.2,0,0,0-.5-.937l-.653-.653A2.231,2.231,0,0,1,51.9,8.381V8.157A1.38,1.38,0,0,1,53.458,6.7c1.112,0,1.551.546,1.551,1.5v.536H53.994V8.167c0-.381-.176-.566-.526-.566a.487.487,0,0,0-.527.546v.136c0,.371.2.586.527.9l.712.7a2.222,2.222,0,0,1,.9,1.717v.322a1.432,1.432,0,0,1-1.619,1.551,1.377,1.377,0,0,1-1.571-1.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.947,10.479H56.874V13.4H55.762V6.782h1.112v2.8h1.073v-2.8h1.122V13.4H57.947Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.112,
    height: 6.614,
    transform: "translate(59.801 6.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.767,7.688v2.605h.41a.479.479,0,0,0,.547-.547V8.225c0-.361-.167-.537-.547-.537Zm-1.112-.907H63.3c1.122,0,1.532.556,1.532,1.483v1.4c0,.926-.41,1.492-1.532,1.492h-.537V13.4H61.655Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.266,11.971v-.888H66.3v.907c0,.371.166.586.547.586.35,0,.507-.234.507-.586v-.253a1.2,1.2,0,0,0-.5-.937l-.653-.653a2.231,2.231,0,0,1-.927-1.766V8.157A1.38,1.38,0,0,1,66.837,6.7c1.112,0,1.551.546,1.551,1.5v.536H67.373V8.167c0-.381-.176-.566-.526-.566a.487.487,0,0,0-.527.546v.136c0,.371.2.586.527.9l.712.7a2.222,2.222,0,0,1,.9,1.717v.322a1.432,1.432,0,0,1-1.619,1.551,1.377,1.377,0,0,1-1.571-1.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.847,16.389h2.646v.922H26.977v1.922h1.129v.911H26.977v2.963h-1.13Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.168,21.551V17.945c0-.407-.178-.694-.584-.694s-.575.287-.575.694v3.606c0,.407.178.694.575.694s.584-.287.584-.694m-2.289-.178v-3.25a1.712,1.712,0,1,1,3.419,0v3.25a1.712,1.712,0,1,1-3.419,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.171,17.31V19.4h.376a.489.489,0,0,0,.555-.555v-.991c0-.367-.169-.545-.555-.545Zm0,2.715v3.082h-1.13V16.389h1.645c1.14,0,1.556.564,1.556,1.506v.862c0,.723-.258,1.149-.9,1.3l1.079,3.052H35.23Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.015,16.389h3v.922h-.931v5.8h-1.14v-5.8h-.931Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.772,20.144h-1.09v2.963h-1.13V16.389h1.13v2.844h1.09V16.389h1.14v6.718h-1.14Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.655,16.389H48.35v.922H46.785v1.922H47.9v.911H46.785v2.042H48.35v.921H45.655Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.957,19.52h1.6v3.587H52.75v-.733a1.018,1.018,0,0,1-1.08.812c-.971,0-1.418-.773-1.418-1.813v-3.25a1.593,1.593,0,0,1,1.695-1.814c1.248,0,1.615.694,1.615,1.685v.594h-1.03v-.683c0-.416-.159-.654-.565-.654s-.585.287-.585.693v3.607c0,.406.169.694.555.694.367,0,.555-.208.555-.644V20.412h-.535Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.485,21.551V17.945c0-.407-.178-.694-.584-.694s-.575.287-.575.694v3.606c0,.407.178.694.575.694s.584-.287.584-.694M54.2,21.373v-3.25a1.712,1.712,0,1,1,3.419,0v3.25a1.712,1.712,0,1,1-3.419,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.349,20.977h.9l-.446-2.695h-.01Zm-1.417,2.13L59.2,16.389h1.289l1.278,6.718H60.608L60.4,21.878H59.2L59,23.107Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.421,16.389h1.13v5.8H64.9v.921H62.421Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3,21.66v-.9h1.05v.922c0,.376.169.594.555.594.357,0,.516-.238.516-.594v-.258a1.214,1.214,0,0,0-.506-.951l-.663-.664a2.267,2.267,0,0,1-.942-1.794v-.227A1.4,1.4,0,0,1,66.9,16.309c1.13,0,1.576.555,1.576,1.526v.545H67.444V17.8c0-.387-.178-.575-.535-.575a.5.5,0,0,0-.535.555v.138c0,.377.208.6.535.912l.724.713a2.258,2.258,0,0,1,.911,1.744v.327A1.455,1.455,0,0,1,66.9,23.186a1.4,1.4,0,0,1-1.6-1.526",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG17);
export default __webpack_public_path__ + "static/media/G17.7b818dd0531dd2e4d49d3e2dfe289d3b.svg";
export { ForwardRef as ReactComponent };